import React from 'react'
import Grid from '@mui/material/Grid';
import UiInput from '../../../../_uiMocks/_uiComponents/UiInput';
import { UiButton } from '../../../../_uiComponents/common/form/UiButton';
import { Box } from '@mui/material';
import { useNavigate } from "react-router-dom";
import UiCheckbox from '../../../../_uiComponents/common/form/UiCheckBox';


export function SignInForm(props) {
    const navigate = useNavigate();
    const handleLogin = () => {
        let path = `/otp-verify`;
        navigate(path);
    }
    const handleForgetPassword = () => {
        let path = `/forget-password`;
        navigate(path);
    }


    return (
        <>
            <Box component="div" sx={{ width: '100%' }}>
                <UiInput type="text" label="Username" />
                <UiInput type="password" label="Password" />

                <Grid container >
                    <Grid item xs={6} lg={4} sx={{ textAlign: 'left' }}>
                        <UiCheckbox label="Remember me" />
                    </Grid>
                </Grid>

                <Grid container sx={{ mb: 3 }} >
                    <Grid alignItems="center" display="flex" item xs={6} sx={{ textAlign: 'left' }}>
                        <span variant="body2" className='sba-forgot-password-link' onClick={handleForgetPassword}>
                            Forgot your password?
                        </span>
                    </Grid>
                    <Grid item xs={6} sx={{ textAlign: 'right' }}>
                        <UiButton name="Next" variant="contained" size="large" onClick={handleLogin} />
                    </Grid>
                </Grid>
                <p className='sba-login-bottom-support-mail'>Please reach <span>support@sherbetrewards.com </span>for further queries</p>
            </Box>

        </>
    )
}
